/**
 * Recording state machine. Pure logic — drives both web's
 * MediaRecorder wrapper and native's expo-audio recorder. UI
 * components subscribe to state changes; emitters call the action
 * functions.
 */
export type RecorderState =
  | { kind: "idle" }
  | { kind: "recording"; startedAt: number }
  | { kind: "stopped"; durationMs: number; blob: Uint8Array; mimeType: string };

export type RecorderEvent =
  | { kind: "start" }
  | { kind: "stop"; blob: Uint8Array; mimeType: string }
  | { kind: "cancel" }
  | { kind: "reset" };

export function recorderReducer(state: RecorderState, ev: RecorderEvent): RecorderState {
  switch (state.kind) {
    case "idle":
      if (ev.kind === "start") return { kind: "recording", startedAt: Date.now() };
      return state;
    case "recording":
      if (ev.kind === "stop") {
        return {
          kind: "stopped",
          durationMs: Date.now() - state.startedAt,
          blob: ev.blob,
          mimeType: ev.mimeType,
        };
      }
      if (ev.kind === "cancel") return { kind: "idle" };
      return state;
    case "stopped":
      if (ev.kind === "reset") return { kind: "idle" };
      return state;
  }
}

export const initialRecorderState: RecorderState = { kind: "idle" };
